const formatMileage = (mileage: string | number): string => {
    let mileageStr = String(mileage).replace(/Miles|mi|,/gi, '').replace(/Shown/gi, '').trim();
    if (mileageStr.indexOf('k') > -1) {
        mileageStr = mileageStr.replace('k', '000');
    }
    const mileageNumber = Number(mileageStr);
    if (isNaN(mileageNumber)) {
        return String(mileage); // Return the original mileage value if conversion results in NaN
    }
    return `${mileageNumber.toLocaleString()} miles`;
};

export const transformWebsiteName = (website: string): string => {
    switch (website) {
        case 'Cars and Bids':
            return 'Cars and Bids';
        case 'Bring a Trailer':
            return 'Bring a Trailer';
        case 'Hagerty Marketplace':
            return 'Hagerty Marketplace';
        case 'PCARMARKET':
            return 'PCARMARKET';
        case 'The MB Market':
            return 'The MB Market';
        default:
            return website;
    }
};


export const formatCarData = (cars: any[]) => {
    if (!cars) return [];
    return cars.map((car: any, index: number) => ({
        key: car.Link || index.toString(),
        name: car.Name,
        currentBid: (car.Price === -1 || car.Price === 0) ? "No Bids" : `$${car.Price.toLocaleString()}`,
        timeLeft: car.EndTime,
        LastUpdated: car.LastUpdated,
        location: car.Location == null || car.Location === "-1" || car.Location === -1 ? "Unavailable" : car.Location,
        reserveStatus: car.reserveStatus,
        reserveMet: car?.reserveMet,
        website: transformWebsiteName(car.Website),
        image: car.imageLink,
        link: car.Link,
        AveragePrice: car.AveragePrice == null || car.AveragePrice === -1
            ? "Coming Soon"
            : `$${car.AveragePrice.toLocaleString()}`,
        Favorited: car.Favorited,
        AdditionalImages: car.additionalImageLinks,
        Bids: (car.Bids === -1 || car.Bids === 0) ? "No Bids" : `${car.Bids}`,
        Make: car.Make,
        Model: car.Model,
        Trim: car.Trim,
        Year: car.Year,
        Comments: `${car.Comments}`,
        Description: car.Description,
        Drivetrain: car.Drivetrain,
        Transmission: car.Transmission,
        Engine: car.Engine,
        VIN: car.VIN,
        Mileage: formatMileage(car.Mileage),
        bodyClass: car.bodyClass,
        exteriorColor: car.exteriorColor,
        interiorColor: car.interiorColor,
        sellerType: car.sellerType,
        titleStatus: car.titleStatus,
        heat_score: (car.heat_score > 10) ? 10 : Math.round(car.heat_score),
        listingDate: car.listing_date,
        isClassified: car.isClassified,
    }));
};
